import { render, staticRenderFns } from "./MedicineGroups.vue?vue&type=template&id=2e169cb8&"
import script from "./MedicineGroups.vue?vue&type=script&lang=js&"
export * from "./MedicineGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports